// import Vue from 'vue'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Event Bus
import eventBus from 'vue3-eventbus';
import BaseCard from '@/components/fchq/UI/BaseCard.vue';
import BaseButton from '@/components/fchq/UI/BaseButton.vue';
import BaseDialog from '@/components/fchq/UI/BaseDialog';
import BaseDialogNoButton from '@/components/fchq/UI/BaseDialogNoButton';

// Vue.config.productionTip = false
const app = createApp(App);
app.use(eventBus)
app.component('base-card', BaseCard);
app.component('base-button', BaseButton);
app.component('base-dialog', BaseDialog);
app.component('base-dialog-no-button', BaseDialogNoButton);
app.use(router).mount('#app')
